<template>
  <div class="options">
    <BaseButton
      v-if="canTranslate"
      outline
      size="small"
      @click="openTranslation"
    >
      {{ $t('ai.TRANSLATE_FROM_OTHER_LANGUAGE') }}
    </BaseButton>
    <BaseButton v-if="canShorten" outline size="small" @click="openShorten">
      {{ $t('ai.SHORTEN') }}
    </BaseButton>

    <div v-if="!isOptionsAvailable">{{ $t('ai.NO_OPTIONS_AVAILABLE') }}</div>
  </div>
</template>

<script>
import BaseButton from '@/components/generics/base/BaseButton.vue'

export default {
  components: {
    BaseButton,
  },
  props: {
    canTranslate: {
      type: Boolean,
      required: false,
      default: false,
    },

    canShorten: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['onOpenTranslation', 'onOpenShorten'],
  computed: {
    isOptionsAvailable() {
      return this.canTranslate || this.canShorten
    },
  },

  methods: {
    openTranslation() {
      this.$emit('onOpenTranslation')
    },

    openShorten() {
      this.$emit('onOpenShorten')
    },
  },
}
</script>

<style lang="scss" scoped>
.options {
  display: flex;
  align-items: flex-start;
  gap: $spacing-3xs;
  border-radius: $spacing-3xs;
  border-top-left-radius: 0;
  display: flex;
  flex-wrap: wrap;
  gap: $spacing-4xs;
}
</style>
